import axios from "axios";

const API = axios.create({
    baseURL: process.env.REACT_APP_API,
    timeout: 120000,
});

API.interceptors.request.use(
    (config) => {
        let jwt = localStorage.getItem('jwt');
        if (jwt) {
            let jwtMFA = localStorage.getItem('jwtMFA');
            if (jwtMFA) {
                config.headers.Authorization = `Bearer ${jwt} ${jwtMFA}`;
            }else {
                config.headers.Authorization = `Bearer ${jwt}`;
            }

            let accountId = localStorage.getItem('accountid');
            if (accountId) {
                config.headers.Accountid = localStorage.getItem('accountid');
            }
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

API.interceptors.response.use(response => {
    return response;
}, error => {
    if (error.response.status === 401) {
        let refreshPage = false;

        console.log(error?.response?.data);

        if (error?.response?.data?.NeedMFATokenRefresh === 1) {
            localStorage.removeItem('jwtMFA');
            refreshPage = true;
        }
        if (error?.response?.data?.NeedTokenRefresh === 1) {
            localStorage.removeItem('jwt');
            refreshPage = true;
        }

        if (error?.response?.data?.NeedAccountRefresh === 1) {
            localStorage.removeItem('accountid');
            window.location.reload();
        }else {
            if (refreshPage) {
                localStorage.removeItem('user');
                window.location.reload();
            } else {
                return Promise.reject(error);
            }
        }
    }else {
        return Promise.reject(error);
    }
});

export default API;
